import { FC } from 'react'
import clsx from 'clsx'
import { useT } from '_metronic/i18n/Metronici18n'
import { SncrBloco, numerosUsadosDoBloco } from '../../../core/_models'

type IProps = {
  bloco: SncrBloco
}

/** Saldo do bloco: número forte, barra do que ainda resta e, embaixo, quantos já foram consumidos. */
export const SncrSaldoCell: FC<IProps> = ({ bloco }) => {
  const { t } = useT()
  const usados = numerosUsadosDoBloco(bloco)
  const esgotado = bloco.saldo === 0
  const fracao = bloco.quantidade > 0 ? bloco.saldo / bloco.quantidade : 0
  const percentual = Math.round(fracao * 100)

  return (
    <div>
      <div className='d-flex align-items-baseline gap-1'>
        <span
          className={clsx('fw-bold', esgotado ? 'text-gray-600' : 'text-gray-900')}
          style={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {esgotado ? t('sncr.lista.esgotado') : bloco.saldo}
        </span>
        {!esgotado && (
          <span className='fs-8 text-gray-700'>
            {t('sncr.lista.saldo_de', { quantidade: bloco.quantidade })}
          </span>
        )}
      </div>
      {/* A barra é reforço visual; o número e o texto carregam o significado. */}
      <div className='progress bg-gray-200 my-1' style={{ height: 6 }} aria-hidden='true'>
        <div
          className={clsx(
            'progress-bar',
            esgotado ? 'bg-gray-500' : fracao < 0.2 ? 'bg-warning' : 'bg-success'
          )}
          style={{ width: `${percentual}%` }}
        />
      </div>
      <span className='fs-8 text-gray-700'>
        {usados > 0 ? t('sncr.lista.usados', { quantidade: usados }) : t('sncr.lista.nenhum_usado')}
      </span>
    </div>
  )
}
